const formatadorMoeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export function formatarMoeda(valor: number | string | null | undefined): string {
  const numero = typeof valor === 'number' ? valor : Number(valor) || 0;
  return formatadorMoeda.format(numero);
}

export function formatarData(data: string): string {
  return new Date(data).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
}

export function formatarDataHoje(): string {
  return new Date().toLocaleDateString('pt-BR');
}

const formatadorQuantidade = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 4 });

export function formatarQuantidade(valor: number | string | null | undefined): string {
  const numero = typeof valor === 'number' ? valor : Number(valor) || 0;
  return formatadorQuantidade.format(numero);
}
